import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { notification } from 'antd';
import { NotificationInfo, selectNotification, showGlobalNotification } from '@src/features/interface/interfaceSlice';


const GlobalNotifications = () => {
  const [api, contextHolder] = notification.useNotification();
  const info = useSelector(selectNotification);
  const lastShownNotification = useRef<NotificationInfo | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (info && info !== lastShownNotification.current) {
      lastShownNotification.current = info;
      api.open({
        type: info.type,
        message: info.title || undefined,
        description: info.message,
        placement: 'topRight',
        showProgress: info.showProgress,
        duration: info.duration,
        key: info.code,
        onClose: () => {
          api.destroy();
        },
      });

      dispatch(showGlobalNotification(null));
    }

  }, [info, api, dispatch]);

  return contextHolder;
};

export default GlobalNotifications;
